import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errorText } from "@/lib/api";
import { startCheckout } from "@/lib/checkout";
import { PLANS } from "@/components/onboarding/PlanPicker";

export const PaymentDue = ({ user }) => {
  const [busy, setBusy] = useState(false);
  const plan = PLANS.find((p) => p.id === user.plan) || PLANS[0];
  const pay = async () => {
    setBusy(true);
    try { await startCheckout(); } catch (e) { toast.error(errorText(e)); setBusy(false); }
  };
  return (
    <section className="max-w-xl rounded-lg border border-amber-500/40 bg-amber-500/5 p-6 space-y-4" data-testid="payment-due-card">
      <p className="font-mono text-xs tracking-[0.3em] uppercase text-amber-400">Payment needed</p>
      <h2 className="text-2xl font-semibold text-slate-50">Finish paying to activate {user.company || "your property"}</h2>
      <p className="text-sm text-slate-400">{plan.title}: {plan.lines.join(" · ")}</p>
      <Button onClick={pay} disabled={busy} className="bg-emerald-500 hover:bg-emerald-400 text-[#07090E] font-semibold" data-testid="payment-due-pay-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : `Pay $${plan.today + 49} now`}
      </Button>
    </section>
  );
};
